import { all_routes } from "../../../../feature-module/router/all_routes";

// export const header = [
//   {
//     title: "Home",
//     base: "home",
//     showAsTab: false,
//     separateRoute: true,
//     menu: [
//       {
//         menuValue: "Home 1",
//         img: "assets/img/home/home-01.jpg",
//         route: all_routes.homeone,
//         hasSubRoute: false,
//         showSubRoute: false,
//         subMenus: [],
//       },
//       {
//         menuValue: "Home 2",
//         img: "assets/img/home/home-02.jpg",
//         route: all_routes.hometwo,
//         hasSubRoute: false,
//         showSubRoute: false,
//         subMenus: [],
//       },
//       {
//         menuValue: "Home 3",
//         img: "assets/img/home/home-03.jpg",
//         route: all_routes.homethree,
//         hasSubRoute: false,
//         showSubRoute: false,
//         subMenus: [],
//       },
//       {
//         menuValue: "Home 4",
//         img: "assets/img/home/home-04.jpg",
//         route: all_routes.homefour,
//         hasSubRoute: false,
//         showSubRoute: false,
//         subMenus: [],
//       },
//       {
//         menuValue: "Home 5",
//         img: "assets/img/home/home-05.jpg",
//         route: all_routes.homefive,
//         hasSubRoute: false,
//         showSubRoute: false,
//         subMenus: [],
//       },
//       {
//         menuValue: "Home 6",
//         img: "assets/img/home/home-06.jpg",
//         route: all_routes.homesix,
//         hasSubRoute: false,
//         showSubRoute: false,
//         subMenus: [],
//       },
//     ],
//   },
//   {
//     title: "Programs",
//     base: "course",
//     showAsTab: false,
//     separateRoute: false,
//     menu: [
//       {
//         menuValue: "Course",
//         hasSubRoute: true,
//         showSubRoute: true,
//         showAsTab2: false,
//         subMenus: [
//           {
//             menuValue: "Course Grid",
//             route: all_routes.courseGrid,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Course List",
//             route: all_routes.courseList,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//         ],
//       },
//       {
//         menuValue: "Course Category",
//         hasSubRoute: true,
//         showSubRoute: true,
//         showAsTab2: false,
//         subMenus: [
//           {
//             menuValue: "Course Category",
//             route: all_routes.courseCategory,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Course Category 2",
//             route: all_routes.courseCategory2,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Course Category 3",
//             route: all_routes.courseCategory3,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//         ],
//       },
//       {
//         menuValue: "Course Details",
//         hasSubRoute: true,
//         showSubRoute: true,
//         showAsTab2: false,
//         subMenus: [
//           {
//             menuValue: "Course Details",
//             route: all_routes.courseDetails,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Course Details 2",
//             route: all_routes.courseDetails2,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//         ],
//       },
//       {
//         menuValue: "Course Resume",
//         route: all_routes.courseResume,
//         hasSubRoute: false,
//         showSubRoute: false,
//         subMenus: [],
//       },
//       {
//         menuValue: "Course Watch",
//         route: all_routes.courseWatch,
//         hasSubRoute: false,
//         showSubRoute: false,
//         subMenus: [],
//       },
//       {
//         menuValue: "Course Cart",
//         route: all_routes.courseCart,
//         hasSubRoute: false,
//         showSubRoute: false,
//         subMenus: [],
//       },
//       {
//         menuValue: "Course Checkout",
//         route: all_routes.courseCheckout,
//         hasSubRoute: false,
//         showSubRoute: false,
//         subMenus: [],
//       },
//       {
//         menuValue: "Add New Course",
//         route: all_routes.addNewCourse,
//         hasSubRoute: false,
//         showSubRoute: false,
//         base: "courses",
//         page: "add-new-course",
//         last: "",
//         subMenus: [],
//       },
//     ],
//   },
//   {
//     title: "Dashboard",
//     base: "instructor",
//     base2: "student",
//     showAsTab: false,
//     separateRoute: false,
//     menu: [
//       {
//         menuValue: "Instructor",
//         hasSubRoute: true,
//         showSubRoute: true,
//         showAsTab2: false,
//         base: "instructor",
//         subMenus: [
//           {
//             menuValue: "Dashboard",
//             route: all_routes.instructorDashboard,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "My Profile",
//             route: all_routes.instructorProfile,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Course",
//             route: all_routes.instructorCourse,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Announcements",
//             route: all_routes.instructorAnnouncements,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Assignment",
//             route: all_routes.instructorAssignment,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Student",
//             hasSubRoute: true,
//             showSubRoute: true,
//             showAsTab2: false,
//             subMenus: [
//               {
//                 menuValue: "Student Grid",
//                 route: all_routes.studentsGrid,
//                 hasSubRoute: false,
//                 showSubRoute: false,
//                 subMenus: [],
//               },
//               {
//                 menuValue: "Student List",
//                 route: all_routes.studentsList,
//                 hasSubRoute: false,
//                 showSubRoute: false,
//                 subMenus: [],
//               },
//               {
//                 menuValue: "Student Details",
//                 route: all_routes.studentsDetails,
//                 hasSubRoute: false,
//                 showSubRoute: false,
//                 subMenus: [],
//               },
//             ],
//           },
//           {
//             menuValue: "Quiz",
//             route: all_routes.instructorQuiz,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Quiz Results",
//             route: all_routes.instructorQuizResult,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Certificate",
//             route: all_routes.instructorCertificate,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Earning",
//             route: all_routes.instructorEarning,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },

//           {
//             menuValue: "Payout",
//             route: all_routes.instructorPayout,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Statement",
//             route: all_routes.instructorStatements,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },

//           {
//             menuValue: "Support Ticket",
//             route: all_routes.instructorTickets,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Settings",
//             route: all_routes.instructorsettings,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//         ],
//       },
//       {
//         menuValue: "Student",
//         hasSubRoute: true,
//         showSubRoute: true,
//         showAsTab2: false,
//         base: "student",
//         subMenus: [
//           {
//             menuValue: "Student Dashboard",
//             route: all_routes.studentDashboard,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "My Profile",
//             route: all_routes.studentProfile,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Enrolled Course",
//             route: all_routes.studentCourses,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "My Certificates",
//             route: all_routes.studentCertificates,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Wishlist",
//             route: all_routes.studentWishlist,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },

//           {
//             menuValue: "Reviews",
//             route: all_routes.studentReviews,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "My Quiz Attempts",
//             route: all_routes.studentQuiz,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },

//           {
//             menuValue: "Order History",
//             route: all_routes.studentOrderHistory,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Referrals",
//             route: all_routes.studentReferral,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Messages",
//             route: all_routes.studentMessage,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Support Ticket",
//             route: all_routes.studentTickets,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Settings",
//             route: all_routes.studentSettings,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//         ],
//       },
//     ],
//   },
//   {
//     title: "Pages",
//     showAsTab: false,
//     separateRoute: false,
//     base: "pages",
//     menu: [
//       {
//         menuValue: "Instructors",
//         hasSubRoute: true,
//         showSubRoute: true,
//         showAsTab2: false,
//         subMenus: [
//           {
//             menuValue: "Instructor Grid",
//             route: all_routes.instructorGrid,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Instructor List",
//             route: all_routes.instructorList,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Instructor Details",
//             route: all_routes.instructorDetails,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//         ],
//       },
//       {
//         menuValue: "About Us",
//         route: all_routes.about_us,
//         hasSubRoute: false,
//         showSubRoute: false,
//         subMenus: [],
//       },
//       {
//         menuValue: "Contact Us",
//         route: all_routes.contactUs,
//         hasSubRoute: false,
//         showSubRoute: false,
//         subMenus: [],
//       },
//       {
//         menuValue: "Notification",
//         route: all_routes.notification,
//         hasSubRoute: false,
//         showSubRoute: false,
//         subMenus: [],
//       },
//       {
//         menuValue: "Become an Instructor",
//         route: all_routes.becomeAnInstructor,
//         hasSubRoute: false,
//         showSubRoute: false,
//         subMenus: [],
//       },
//       {
//         menuValue: "Testimonials",
//         route: all_routes.testimonials,
//         hasSubRoute: false,
//         showSubRoute: false,
//         subMenus: [],
//       },
//       {
//         menuValue: "Authentication",
//         hasSubRoute: true,
//         showSubRoute: true,
//         showAsTab2: false,
//         subMenus: [
//           {
//             menuValue: "Login",
//             route: all_routes.login,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Register",
//             route: all_routes.register,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Forgot Password",
//             route: all_routes.forgotpassword,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           // {
//           //   menuValue: "Reset Password",
//           //   route: "blogListSidebarRight",
//           //   hasSubRoute: false,
//           //   showSubRoute: false,
//           //   subMenus: [],
//           // },
//           {
//             menuValue: "Set Password",
//             route: all_routes.setpassowrd,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "OTP",
//             route: all_routes.otp,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Lock Screen",
//             route:all_routes.lockscreen,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//         ],
//       },
//       {
//         menuValue: "Error",
//         hasSubRoute: true,
//         showSubRoute: true,
//         showAsTab2: false,
//         subMenus: [
//           {
//             menuValue: "400 Error",
//             route: all_routes.Error404,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "500 Error",
//             route: all_routes.Error500,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//         ],
//       },
//       {
//         menuValue: "Pricing Plan",
//         route: all_routes.pricingPlan,
//         hasSubRoute: false,
//         showSubRoute: false,
//         subMenus: [],
//       },
//       {
//         menuValue: "FAQ",
//         route: all_routes.FAQ,
//         hasSubRoute: false,
//         showSubRoute: false,
//         subMenus: [],
//       },
//       {
//         menuValue: "Comming Soon",
//         route: all_routes.comingSoon,
//         hasSubRoute: false,
//         showSubRoute: false,
//         subMenus: [],
//       },
//       {
//         menuValue: "Under Construction",
//         route: all_routes.underconstruction,
//         hasSubRoute: false,
//         showSubRoute: false,
//         subMenus: [],
//       },
//       {
//         menuValue: "Terms & Conditions",
//         route: all_routes.termsConditions,
//         hasSubRoute: false,
//         showSubRoute: false,
//         subMenus: [],
//       },
//       {
//         menuValue: "Privacy Policy",
//         route: all_routes.privacyPolicy,
//         hasSubRoute: false,
//         showSubRoute: false,
//         subMenus: [],
//       },
//     ],
//   },
//   {
//     title: "Blog",
//     showAsTab: false,
//     separateRoute: false,
//     base: "blog",
//     menu: [
//       {
//         menuValue: "Blog Layouts",
//         hasSubRoute: true,
//         showSubRoute: true,
//         showAsTab2: false,
//         subMenus: [
//           {
//             menuValue: "Blog 1 Grid",
//             route: all_routes.blogGrid,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Blog 2 Grid",
//             route: all_routes.blogGrid2,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Blog 3 Grid",
//             route: all_routes.blogGrid3,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Blog Carousal",
//             route: all_routes.blogCarousal,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Blog Mansory",
//             route: all_routes.blogMasonry,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Blog Left Sidebar",
//             route: all_routes.blogLeftSidebar,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Blog Right Sidebar",
//             route: all_routes.blogRightSidebar,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//         ],
//       },
//       {
//         menuValue: "Blog Details",
//         hasSubRoute: true,
//         showSubRoute: true,
//         showAsTab2: false,
//         subMenus: [
//           {
//             menuValue: "Blog Details",
//             route: all_routes.blogDetails,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Blog Details Sidebar Left",
//             route: all_routes.blogDetailsLeftSidebar,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//           {
//             menuValue: "Blog Details Sidebar Right",
//             route: all_routes.blogDetailsRightSidebar,
//             hasSubRoute: false,
//             showSubRoute: false,
//             subMenus: [],
//           },
//         ],
//       },
//     ],
//   },
// ];

export const commonHeader = [
    {
        title: "Students",
        base: "student",
        showAsTab: false,
        separateRoute: true,
    },
    {
        title: "Institutions",
        base: "institution",
        showAsTab: false,
        separateRoute: true,
    },
    {
        title: "Recruiters",
        base: "recruiter",
        showAsTab: false,
        separateRoute: true,
    },
]

export const studentHeader = [
    {
        title: "Dashboard",
        base: "student",
        showAsTab: false,
        separateRoute: false,
        menu: [
            {
                menuValue: "Student Dashboard",
                route: all_routes.studentDashboard,
                hasSubRoute: false,
                showSubRoute: false,
                subMenus: [],
            },
            {
                menuValue: "My Profile",
                route: all_routes.studentProfile,
                hasSubRoute: false,
                showSubRoute: false,
                subMenus: [],
            },
            {
                menuValue: "Applications",
                route: all_routes.studentApplications,
                hasSubRoute: false,
                showSubRoute: false,
                subMenus: [],
            },
            {
                menuValue: "Settings",
                route: all_routes.studentSettings,
                hasSubRoute: false,
                showSubRoute: false,
                subMenus: [],
            },
        ],
    },
]

export const instAdminHeader = [
    {
        title: "Dashboard",
        base: "institution",
        showAsTab: false,
        separateRoute: false,
        menu: [
            {
                menuValue: "Institution Dashboard",
                route: all_routes.institutionDashboard,
                hasSubRoute: false,
                showSubRoute: false,
                subMenus: [],
            },
            {
                menuValue: "Programs",
                route: all_routes.institutionPrograms,
                hasSubRoute: false,
                showSubRoute: false,
                subMenus: [],
            },
            {
                menuValue: "Applications",
                route: all_routes.institutionApplications,
                hasSubRoute: false,
                showSubRoute: false,
                subMenus: [],
            },
            {
                menuValue: "Profile",
                route: all_routes.institutionProfile,
                hasSubRoute: false,
                showSubRoute: false,
                subMenus: [],
            },
        ],
    },
]

export const recruiterHeader = [
    {
        title: "Dashboard",
        base: "recruiter",
        showAsTab: false,
        separateRoute: false,
        menu: [
            {
                menuValue: "Recruiter Dashboard",
                route: all_routes.recruiterDashboard,
                hasSubRoute: false,
                showSubRoute: false,
                subMenus: [],
            },
            {
                menuValue: "Students",
                route: all_routes.recruiterStudents,
                hasSubRoute: false,
                showSubRoute: false,
                subMenus: [],
            },
            {
                menuValue: "Account Managers",
                route: all_routes.recruiterAccountManagers,
                hasSubRoute: false,
                showSubRoute: false,
                subMenus: [],
            },
            {
                menuValue: "Applications",
                route: all_routes.recruiterApplications,
                hasSubRoute: false,
                showSubRoute: false,
                subMenus: [],
            },
            {
                menuValue: "Settings",
                route: all_routes.recruiterSettings,
                hasSubRoute: false,
                showSubRoute: false,
                subMenus: [],
            },
        ],
    },
];